import api from "../services/apiHub";
import getHeaders from "../utils/returnHeadersHub";

export default class LeadManagementRepository {
	create = async (data) => {
		const header = getHeaders();
		return api.post(`/api/lead-mgmt`, data, header);
	};
}
